$(function () {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
    
    $('a[href="#"]').on("click", function (e) {
        e.preventDefault();
    });

    // search box
    if ($(".locality").length) {
        let searchURL = $(".locality").attr("data-url");

        $(".locality").keyup(function () {
            var keyword = $(this).val();
            if (keyword.length < 3) return false;

            var formData = $("#frmSearch")
                .find(":not(input[name=location])")
                .serialize();

            $.ajax({
                type: "GET",
                url: searchURL,
                data: formData,
                dataType: 'html',
                success: function (data) {
                    $("#localitylist").show();
                    $("#localitylist").html(data);
                },
            });
        });

        $("body").click(function (e) {
            if (e.target.id != "localitylist") {
                $("#localitylist").show();
                $("#localitylist").html("");
            }
        });

        $("#frmSearch").submit(function (event) {
            event.preventDefault();

            const keyword = $(this).find("#keyword").val();

            if (keyword.length) {
                const targetUrl = $(this).attr("action");
                window.location.href = targetUrl + "?keyword=" + keyword;
            }
        });
    }

    // pagination
    $(document).on("click", ".page-link", function (event) {
        event.preventDefault();

        getLocationList($(this).data("url"));

        setTimeout(function () {
            $("#localitylist").hide();
            $("#localitylist").html("");
        }, 300);
    });

    // sorting dropdown
    $(document).on("change", "#ratingOrder", function (event) {
        if ($(this).val() == "") return false;

        const targetUrl = new URL($(this).data("url"));
        let queryParams = targetUrl.searchParams;

        queryParams.delete("page");
        queryParams.set("ratingOrder", $(this).val());

        targetUrl.search = queryParams.toString();

        getLocationList(targetUrl.toString());

        setTimeout(function () {
            $("#localitylist").hide();
            $("#localitylist").html("");
        }, 300);
    });

    // Geo location search
    $("#div-store-locator, #anchor-store-locator").on("click", function () {
        var form = $(this).closest("form");
        clearFormFields(form);
        getCurrentLocation();
    });

    $("div.data-view-type > .active").trigger("click");

    // attribute js
    if ($(".attributeGroup").length) {
        $(".attributeGroup").on("click", function () {
            $(".attributeList").slideUp();
            var attrEl = $(this).next("div.attributeList");
            if (attrEl.is(":visible")) attrEl.slideUp();
            else attrEl.slideDown();
        });

        // attributes popup js
        $("#show-more-srvc").click(function () {
            $(".modal-container ").show();
        });

        $(".modal-contents .btn-close").click(function () {
            $(".modal-container ").hide();
        });
    }

    // store detail page js
    if ($(".store-banner-slider").length) {
        $(".store-banner-slider").slick({
            infinite: !0,
            speed: 500,
            autoplay: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerPadding: "0px",
            arrows: false,
            dots: $(".store-banner-slider").find('.store-banner-item').length > 1 ? true : false,
            centerMode: true, // Add `true` or `false` here
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        centerMode: !1,
                        slidesToShow: 1,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        centerMode: !1,
                        slidesToShow: 1,
                    },
                },
            ],
        });
    }

    if ($(".product_slider").length) {
        $(".product_slider").slick({
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                    },
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
    }

    if ($(".nearby-stor-slider").length) {
        $(".nearby-stor-slider").slick({
            dots: !1,
            infinite: !0,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
    }

    if ($(".customer_review").length) {
        $(".customer_review").slick({
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
    }

    if ($(".testimonials-slick-slide").length) {
        $(".testimonials-slick-slide").slick({
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            centerPadding: "0px",
            centerMode: false,
            autoplay:true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        centerMode: false,
                        slidesToShow: 2,
                    },
                },

                {
                    breakpoint: 768,
                    settings: {
                        centerMode: false,
                        slidesToShow: 1,
                    },
                },
            ],
        });
    }

    var numItems = $(".lelt_right_spacer").length;
    if (numItems <= 2) {
        $(".lelt_right_spacer").addClass("two-slides");
    }

    // faq accordian js
    if ($(".course-accordion").length) {
        $(".course-accordion").click(function () {
            const getElement = $(this)
                .parents(".accordion-container")
                .siblings(".accordion-container");
            getElement
                .find(".course-accordion")
                .removeClass("active")
                .siblings(".course-panel")
                .slideUp();
            $(this)
                .toggleClass("active")
                .siblings(".course-panel")
                .slideToggle();
        });
    }
});

function getUserLocation() {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(showUserPosition, showError);
    } else {
        showError();
    }
}

function showUserPosition(position) {
    var locationLatLong =
        position.coords.latitude + "|" + position.coords.longitude;
    $("#userLatLng").val(locationLatLong);
    $("#anchor-store-locator").addClass("activeLocation");

    getDataByLatLong();
}

function getDataByLatLong() {
    const userLatLng = $("#frmSearch").find("#userLatLng").val();

    if (userLatLng.length) {
        const targetUrl = $("#frmSearch").attr("action");
        window.location.href = targetUrl + "?location=" + userLatLng;
    }
}

function showError() {
    console.log("navigation error!");
}

function getCurrentLocation() {
    getUserLocation();
}

function clearCurrentLocation() {
    //$('#anchor-store-locator').removeClass("activeLocation");
    $("#userLatLng").val("");
}

function clearFormFields(form) {
    form[0].reset();
    $("#localitylist").html("");
}

function getLocationList(targetUrl, formData = [], contentArea) {
    if (typeof contentArea === "undefined") {
        contentArea = "contentArea";
    }

    $.ajax({
        url: targetUrl,
        data: formData,
        type: "get",
        dataType: 'html',
    })
        .done(function (data) {
            if (data) {
                $("#" + contentArea).html(data);

                if ($(".map-view-store").hasClass("active")) {
                    $(".map-view-store").trigger("click");
                } else if ($(".grid-view-store").hasClass("active")) {
                    $(".grid-view-store").trigger("click") &&
                        $(".grid-view-store").show();
                }
            }
        })
        .fail(function (jqXHR, textStatus, thrownError) {
            console.log(thrownError);
        });
}
